import React from 'react';

const NotificationIcon = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0046 8.31796V15.2832C15.0046 17.0343 13.6041 18.4351 11.8535 18.4351H1V7.57863C1 5.82759 2.40046 4.42676 4.15103 4.42676V4.42676H11.1144"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <ellipse
      cx="14.1099"
      cy="5.28281"
      rx="3.89016"
      ry="3.8912"
      stroke="#555B67"
      strokeWidth="2"
    />
  </svg>
);

export default NotificationIcon;
